export default __webpack_public_path__ + "static/media/Q2_1.71c19cbe.png";